export enum Sort {
  Date = "date",
  Groups = "groups",
  Name = "name",
  Position = "position",
  Trigger = "trigger",
}
